import { Image } from '@mantine/core'
import { RingLoader } from './RingLoader'
import { Match } from '../../matches/api'
import classes from './Round.module.css'
import { Typography } from '../../common/typography'

export default function ActiveRound({ match }: { match: Match }) {
  return (
    <div className={classes.container}>
      <div className={classes.pattern_container} />
      <div className={classes.team_container}>
        <Image
          src={match.home_team_logo.thumbnail}
          alt={match.home_team_name}
          className={classes.team_logo}
          fit="scale-down"
        />
        <Typography
          fc={{ light: 'black', dark: 'gray-3' }}
          ta="center"
          lh="150"
        >
          {match.home_team_name}
        </Typography>
      </div>
      <div className={classes.results_container}>
        <div className={classes.score_container}>
          <Typography
            fs="sm"
            fc={{ light: 'white', dark: 'white' }}
            tt="uppercase"
            lh="85"
            ta="center"
          >
            Score
          </Typography>

          <div className={classes.result_wrapper}>
            <Typography
              fs="xxl"
              fc={{ light: 'white', dark: 'white' }}
              ta="center"
              fw={700}
              lh="100"
            >
              {match.home_team_score}
            </Typography>
            <Typography
              fs="xxl"
              fc={{ light: 'white', dark: 'white' }}
              ta="center"
              fw={700}
              lh="100"
            >
              :
            </Typography>
            <Typography
              fs="xxl"
              fc={{ light: 'white', dark: 'white' }}
              ta="center"
              fw={700}
              lh="100"
            >
              {match.away_team_score}
            </Typography>
          </div>
        </div>
        {match.round_status === 'live' && (
          <div className={classes.round_status_container}>
            <RingLoader />
            <Typography
              fs="sm"
              fw={500}
              fc={{ light: 'gray-9', dark: 'gray-9' }}
              lh="115"
              tt="uppercase"
              ta="center"
            >
              Now playing
            </Typography>
          </div>
        )}
      </div>
      <div className={classes.team_container}>
        <Image
          src={match.away_team_logo.thumbnail}
          alt={match.away_team_name}
          className={classes.team_logo}
          fit="scale-down"
        />
        <Typography
          fc={{ light: 'black', dark: 'gray-3' }}
          ta="center"
          lh="150"
        >
          {match.away_team_name}
        </Typography>
      </div>
    </div>
  )
}
